<template>
<!-- 新增关联弹窗 -->
  <div class="contaier">
     <a-modal class="" title="新增关联" :visible="addRelevanceVisib"  @cancel="closeVisible"  width="70%" @ok="submit" >
       <div class="title">
             <span>污染物类别</span>
        </div>
       <div class="containerTop">
            <a-form-model :model="categories" ref="categoriesRef" >
                <a-row>
                    <a-col :span="12">
                        <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18}"
                            label="行业大类"  prop="masterCategoryId" :rules="{
								  required: true,
								  message: '请选择行业大类',
								  trigger: 'change',
								}">
                        <a-select style="width: 80%;" allowClear placeholder="请选择行业大类" v-model="categories.masterCategoryId" @change="getSubCategory" 
                           show-search :filter-option="filterOption">
                            <a-select-option :value="item.id" v-for="(item, index) in masterCategoryList" :key="index">
                                 {{ item.industryName }}
                            </a-select-option>
                        </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18}"
                            label="行业子类"  prop="subCategoryId" :rules="{
								  required: true,
								  message: '请填选择行业子类',
								  trigger: 'change',
								}">
                            <a-select style="width: 80%;" allowClear placeholder="请选择行业子类" v-model="categories.subCategoryId" 
                           show-search :filter-option="filterOption">
                            <a-select-option :value="item.id" v-for="(item, index) in subCategoryList" :key="index">
                                 {{ item.industryName }}
                            </a-select-option>
                        </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="12" style="margin-top: 10px;">
                        <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18}"
                            label="请选择污染物类别"  prop="pollutantTypeId" :rules="{
								  required: true,
								  message: '请填选择报价过程中的污染物类别',
								  trigger: 'change',
								}">
                            <a-select style="width: 80%;" allowClear placeholder="请填选择报价过程中的污染物类别" v-model="categories.pollutantTypeId" @change="" 
                           show-search :filter-option="filterOption">
                            <a-select-option :value="item.id" v-for="(item, index) in pollutantTypeList" :key="index">
                                 {{ item.pollutantName }}
                            </a-select-option>
                        </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>

            </a-form-model>
        
        </div>
         <div class="title">
             <span>选择污染物</span>
        </div>
        <div class="containerTop" id="content_main_center_scroll">
            <a-input style="width: 240px;margin-top: 10px;margin-right: 20px; " v-model="factorName" allowClear placeholder="污染物名称" @keyup.enter.native="search"/>
            <a-select style="width: 240px;margin-top: 10px;margin-right: 20px;"  allowClear placeholder="请选择收费标准的污染物类别" v-model="categoryId" @keyup.enter.native="search"
                           show-search :filter-option="filterOption">
                    <a-select-option :value="item.categoryId" v-for="(item, index) in detailList" :key="index">
                                 {{ item.categoryName }}
                    </a-select-option>
            </a-select>
            <a-button type="primary" @click="search" style="margin-right: 5px">查询</a-button>
            <div class="containerBottom">
                <a-table :data-source="pollutantList" bordered :loading="loading" :pagination="false" :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }" 
                 :row-selection="{ selectedRowKeys: selectedRowKeys[pagination.current], onChange: onSelectChange }">
                <a-table-column key="index" title="序号" ellipsis="true" data-index="index"  width="100px">
                    <template scope="text, record, index">
                    {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
                    </template>
                </a-table-column>
                <a-table-column key="factorName" title="污染物名称" ellipsis="true" data-index="factorName" />
                <a-table-column key="standardInfo" title="检测标准" ellipsis="true" data-index="standardInfo" />
                <a-table-column key="limitRange" title="限制" ellipsis="true" data-index="limitRange" />
                </a-table>
            </div>
            <div class="pageBottom">
                <a-pagination
                      v-model="pagination.current"
            show-size-changer
            :page-size.sync="pagination.pageSize"
            :total="pagination.totalCount"
			@showSizeChange="onShowSizeChange"
            :pageSizeOptions="['10', '20', '30','40', '50','100','200']"
            @change="onShowSizeChange"
                />
            </div> 

             <!-- <Pagination 
                v-model="pagination.current"
                :total="pagination.totalCount"
                show-size-changer
                :page-size="pagination.pageSize"
                @onShowSizeChange="onShowSizeChange"
            ></Pagination> -->
            


        </div>
     </a-modal>
  </div>
</template>

<script>
import {getPollotantList, getChargeList, addReation} from '@/api/surrounding'
import {industryInfo, baseFactor} from '@/api/Industry'
import Pagination from '@/components/pagination/index.vue'
export default {
      props: [
        'addRelevanceVisib'

    ],
      components: {
        Pagination,
    
     },
    data() {
        return {
            categories: {

            },
            // 行业大类
            masterCategoryList: [],
            // 行业子类
            subCategoryList: [],
            //污染物类别
            pollutantTypeList: [],
            // 污染物列表
            pollutantList: [],
            // 污染物详细列表
            detailList: [],
            scroll_y: 150,
            factorName: '',
            categoryId: undefined,
            selectedRowKeys: {
                1: [],
            },
            selectedData: {},
             pagination:{ 
                //分页数据
                 current : 1,
                 pageSize: 10,
                 totalCount: 0
            },
            // deleteMasterCategoryVisible: false,
        }
    },
    mounted() {
        // this.getPollotant()
        // this.getMasterCategory()
        // this.getDetail()
        // this.getFactor()

        //  this.$nextTick(() => {
		// 		var max_h = $('#content_main_center_scroll').height()
		// 		setTimeout(() => {
		// 			this.scroll_y = max_h - $('.ant-table-header').height() + 480
		// 		}, 1000)
		// 	})
        
    },
    methods: {
        init() {
            this.getMasterCategory()
            this.getPollotant()
            this.getDetail()
            this.getFactor()
            this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
				setTimeout(() => {
					this.scroll_y = max_h - $('.ant-table-header').height() + 480
				}, 1000)
			})
        },
          //分页
        onShowSizeChange(current, pageSize) {
        console.log(current, pageSize);
        this.pagination.current = current
        this.pagination.pageSize = pageSize;
        //改变完 重新渲染数据
         this.getFactor()
      },
      currentLists(){
            console.log('111111111111111111111111111')

        return this.selectedRowKeys[this.pagination.current]
      },
          //选中
        onSelectChange(selectedRowKeys, val) {
            console.log(selectedRowKeys, val, 'valvalvalvalvalvalvalvalval')
            this.selectedRowKeys[this.pagination.current] = selectedRowKeys
             this.selectedData[this.pagination.current] = val
            
            this.getFactor()
            console.log(this.selectedRowKeys[this.pagination.current], 'this.selectedRowKeys[this.pagination.current]')
               console.log(this.selectedRowKeys, 'this.selectedRowKeys[this.pagination.current]')

           
				// this.formFlow.cateModule = val[0].name
				// this.selectval = val[0]

        },
        //查询危害信息基础列表
        getFactor() {
            baseFactor({
                pageNum: this.pagination.current,
		        pageSize: this.pagination.pageSize,
                categoryId: 1001,
                subcategoryId: this.categoryId,
                factorName: this.factorName
            }).then(res => {
                if(res.code == 200) {
                    this.pollutantList = res.data
                    this.pagination.totalCount= res.total
                } else {
                    this.$message.error(res.msg)
                }

            })

        },
        // 查询污染物详细列表
        getDetail() {
              getChargeList({
                parentId: 1001
              }).then(res=> {
                 if(res.code == 200) {
                    this.detailList = res.data

                } else {
                    this.$message.error(res.msg)
                }
            
             })

        },
      
        //获取污染物类别列表
        getPollotant() {
            getPollotantList({
                projectId: 2
            }).then(res => {
                if(res.code == 200) {
                this.pollutantTypeList = res.data.list
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        //查询行业大类列表
        getMasterCategory() {
            industryInfo({
                projectId: 2,
                parentId: 0
            }).then(res => {
                 if(res.code == 200) {
                this.masterCategoryList = res.data
                } else {
                    this.$message.error(res.msg)
                }

            })

        },
        //查询行业大类列表
         getSubCategory(e) {
            console.log(e, 'eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee')
            this.subCategoryList = []
            if(e != undefined) {
                  industryInfo({
                projectId: 2,
                parentId: e
            }).then(res => {
                 if(res.code == 200) {
                this.subCategoryList = res.data
                } else {
                    this.$message.error(res.msg)
                }

            })
            }
            
            

            this.masterCategoryList.forEach(item => {
                if(item.id == e){
                    this.categories.industryName = item.industryName
                }
            })

         },

        // 查询按钮
        search() {
            this.pagination.current = 1
              this.getFactor()

        },
         //查询下拉列表
         filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
        //关闭弹窗
        closeVisible() {
             this.addRelevanceVisib = false
             this.selectedRowKeys = {}
             this.categories = {}
            this.$emit('changeAddRelevanceVisib',this.addRelevanceVisib)


        },
        //提交弹窗数据
        submit() {
            console.log(this.selectedData,'111111111111111111111111111111')
            var obj =this.selectedData
            var ids = []
             for (let i in obj) {
                obj[i].forEach(item => {
                    ids.push(item.id)
                })
          
            }
        Object.assign(this.categories, {
            projectId: 2
        })
             this.$refs.categoriesRef.validate( valid=>{
                 if(valid){
                    if(Object.keys(this.selectedData).length != 0) {
                         addReation({
                           quoteCategoryPollutant: this.categories,
                           ids: ids,
                           
                      }).then(res => {
                        if(res.code == 200) {
                            this.$message.success(res.msg)
                             this.addRelevanceVisib = false
                    this.categories = {}
                    this.selectedRowKeys = {}
                    this.selectedData = {}
                    this.$emit('changeAddRelevanceVisib',this.addRelevanceVisib)
                    this.$emit('changeData')

                        } else {
                            this.$message.error(res.msg)
                        }
                   
                  })

                    }
           
                 }
             })

        }
    }

}
</script>

<style scoped>
.containerTop {
    margin: 10px;
    padding: 5px;
    background-color: #fff;
    border-radius: 15px;
}
.title {
    font-size: 16px;
}
.containerBottom {
    margin-top: 10px;
}
.pageBottom {
    margin: 10px;
    display: flex;
    flex-direction: row-reverse;
}
</style>